import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";

import {
	ColorPicker,
	FileInput,
	GradientInput,
	NumberInput,
	BorderStylePicker,
	CheckBox,
	ShadowInput,
} from "../../../../../shared/Forms";

const Item = ({ themeData, primaryState, checkForEmptyValues }) => {
	const currentElementType = themeData.lists.item;
	const states = Object.keys(currentElementType);
	return (
		<Scope scope="item">
			<div className="theme-columns">
				{states.map(state => {
					const primaryStatePath = `lists.item.${primaryState}`;
					const currentStatePath = `lists.item.${state}`;
					return (
						<Scope scope={state} key={state}>
							<div className="theme-column">
								<h4 className="header">{state}</h4>
								<div className="theme-content">
									{checkForEmptyValues(primaryStatePath, currentStatePath, [
										<ColorPicker
											field="textColor"
											id="textColor"
											placeholder="Text Color"
											themeBuilderInputType="ColorPicker"
										/>,
										<ColorPicker
											field="backgroundColor"
											id="backgroundColor"
											placeholder="Background Color"
											themeBuilderInputType="ColorPicker"
										/>,
										<FileInput
											field="backgroundImageUrl"
											id="backgroundImageUrl"
											placeholder="Background Image URL"
											themeBuilderInputType="FileInput"
										/>,
										<GradientInput
											field="backgroundGradient"
											id="backgroundGradient"
											placeholder="Background Gradient"
											themeBuilderInputType="GradientInput"
										/>,
										<NumberInput
											field="marginVertical"
											id="marginVertical"
											placeholder="Vertical Margin"
											themeBuilderInputType="NumberInput"
										/>,
										<NumberInput
											field="marginHorizontal"
											id="marginHorizontal"
											placeholder="Horizontal Margin"
											themeBuilderInputType="NumberInput"
										/>,
										<NumberInput
											field="paddingVertical"
											id="paddingVertical"
											placeholder="Vertical Padding"
											themeBuilderInputType="NumberInput"
										/>,
										<NumberInput
											field="paddingHorizontal"
											id="paddingHorizontal"
											placeholder="Horizontal Padding"
											themeBuilderInputType="NumberInput"
										/>,
										<BorderStylePicker
											field="borderStyle"
											id="borderStyle"
											placeholder="Border Styles"
											themeBuilderInputType="BorderStylePicker"
										/>,
										<ColorPicker
											field="borderColor"
											id="borderColor"
											placeholder="Border Color"
											themeBuilderInputType="ColorPicker"
										/>,
										<NumberInput
											field="borderWidth"
											id="borderWidth"
											placeholder="Border Width"
											themeBuilderInputType="NumberInput"
										/>,
										<NumberInput
											field="borderRadius"
											id="borderRadius"
											placeholder="Border Radius"
											max={768}
											themeBuilderInputType="NumberInput"
										/>,
										<CheckBox
											field="borderTopOn"
											id={`${state}-borderTopOn`}
											label="Border Top"
											textalign="center"
											themeBuilderInputType="CheckBox"
										/>,
										<CheckBox
											field="borderLeftOn"
											id={`${state}-borderLeftOn`}
											label="Border Left"
											textalign="center"
											themeBuilderInputType="CheckBox"
										/>,
										<CheckBox
											field="borderRightOn"
											id={`${state}-borderRightOn`}
											label="Border Right"
											textalign="center"
											themeBuilderInputType="CheckBox"
										/>,
										<CheckBox
											field="borderBottomOn"
											id={`${state}-borderBottomOn`}
											label="Border Bottom"
											textalign="center"
											themeBuilderInputType="CheckBox"
										/>,
										<ShadowInput
											field="boxShadow"
											id="boxShadow"
											placeholder="Box Shadow"
											themeBuilderInputType="ShadowInput"
										/>,
										<ShadowInput
											field="textShadow"
											type="text"
											id="textShadow"
											placeholder="Text Shadow"
											themeBuilderInputType="ShadowInput"
										/>,
									])}
								</div>
							</div>
						</Scope>
					);
				})}
			</div>
		</Scope>
	);
};

Item.propTypes = {
	checkForEmptyValue: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Item;
